import { Component } from "react";

class Header extends Component {
  state = {};
  render() {
    return (
      <div>
        {/* <div class="nav-header">
          <a href="#" class="brand-logo">
            <img src="images/images/logo-en.svg" alt="" height={200} width={100} />
          </a>
          <div class="nav-control">
            <div class="hamburger">
              <span class="line">
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.7468 5.58925C11.0722 5.26381 11.0722 4.73617 10.7468 4.41073C10.4213 4.0853 9.89369 4.0853 9.56826 4.41073L4.56826 9.41073C4.25277 9.72622 4.24174 10.2342 4.54322 10.5631L9.12655 15.5631C9.43754 15.9024 9.96468 15.9253 10.3039 15.6143C10.6432 15.3033 10.6661 14.7762 10.3551 14.4369L6.31096 10.0251L10.7468 5.58925Z"
                    fill="#452B90"
                  />
                  <path
                    opacity="0.3"
                    d="M16.5801 5.58924C16.9056 5.26381 16.9056 4.73617 16.5801 4.41073C16.2547 4.0853 15.727 4.0853 15.4016 4.41073L10.4016 9.41073C10.0861 9.72622 10.0751 10.2342 10.3766 10.5631L14.9599 15.5631C15.2709 15.9024 15.798 15.9253 16.1373 15.6143C16.4766 15.3033 16.4995 14.7762 16.1885 14.4369L12.1443 10.0251L16.5801 5.58924Z"
                    fill="#452B90"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div> */}
        <div className="header">
          <div className="header-content">
            <nav className="navbar navbar-expand">
              <div className="collapse navbar-collapse justify-content-between">
                <div className="header-left">
                  <div className="dashboard_bar">Malaria DashBoard</div>
                </div>
                <div className="header-right d-flex align-items-center">
                  <ul className="navbar-nav">
                    <li className="nav-item dropdown notification_dropdown">
                      <a
                        class="nav-link "
                        href="javascript:void(0);"
                        data-bs-toggle="dropdown"
                      >
                        <svg
                          style={{ color: "blue" }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-person"
                          viewBox="0 0 16 16"
                        >
                          {" "}
                          <path
                            d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"
                            fill="blue"
                          ></path>{" "}
                        </svg>{" "}
                      </a>
                      <div className="dropdown-menu dropdown-menu-end">
                        <div
                          id="DZ_W_TimeLine02"
                          className="widget-timeline dz-scroll style-1 p-3 height370"
                        >
                          <ul>
                            <li>
                              <div className="timeline-badge primary">
                                <h4>User</h4>
                              </div>
                              <div className="row">
                                <div className="col">Username:</div>
                                <div className="col">adriano</div>
                              </div>

                              <div className="row">
                                <div className="col">Region:</div>
                                <div className="col">Souther Africa</div>
                              </div>

                              <div className="row">
                                <div className="col">Country:</div>
                                <div className="col">South Africa</div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    );
  }
}
export default Header;
